var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.06069 0.93934C2.4749 0.353553 1.52516 0.353553 0.93937 0.93934C0.353584 1.52513 0.353584 2.47487 0.93937 3.06066L7.87871 10L0.93937 16.9393C0.353584 17.5251 0.353584 18.4749 0.93937 19.0607C1.52516 19.6464 2.4749 19.6464 3.06069 19.0607L10 12.1213L16.9394 19.0607C17.5252 19.6464 18.4749 19.6464 19.0607 19.0607C19.6465 18.4749 19.6465 17.5251 19.0607 16.9393L12.1214 10L19.0607 3.06066C19.6465 2.47487 19.6465 1.52513 19.0607 0.93934C18.4749 0.353553 17.5252 0.353553 16.9394 0.93934L10 7.87868L3.06069 0.93934Z","fill":"white"}));
}

Close.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Close;

Close.default = Close;
